import { createContext } from 'react';

import { noop } from '@/utils/noop';

export const RadioContext = createContext<{
  currentValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}>({
  currentValue: '',
  onChange: noop,
});
